<template>
  <div>
    <v-row no-gutters v-for="(item, index) in data" :key="index">
      <v-col cols="12" md="3" class="ml-2">
        <v-select
          :label="$t('weeklyTable.weekDay')"
          v-model="item.weekDay"
          :item-text="`text`"
          :item-value="`value`"
          :items="weekDaysItems"
        ></v-select>
      </v-col>
      <v-col cols="12" md="3" class="ml-2">
        <v-select
          :label="$t('weeklyTable.startTime')"
          v-model="item.from"
          :items="inAHalf ? hoursItemsHalf : hoursItems"
        ></v-select>
      </v-col>
      <v-col cols="12" md="3" class="ml-2">
        <v-select
          :label="$t('weeklyTable.endTime')"
          v-model="item.to"
          :items="perClass > 0 ? [item.to] : hoursItems"
        ></v-select>
      </v-col>
      <v-col cols="12" md="1" class="d-flex align-center justify-center">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-on="on" v-bind="attrs" icon @click="removeItem(index)"
              ><v-icon color="primary-600">mdi-eraser</v-icon></v-btn
            >
          </template>
          <span>{{ $t("common.remove") }}</span>
        </v-tooltip>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" md="9" class="d-flex align-center justify-center">
        <v-btn depressed color="primary" @click="increaseArray"
          >{{ $t("weeklyTable.addTime")
          }}<v-icon>mdi-plus-outline</v-icon></v-btn
        >
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { parse, format, addMinutes } from "date-fns";
import { WEEK_DAY_ITEMS } from "@/shared/classPresentation";
export default {
  props: {
    inAHalf: {
      type: Boolean,
      default: false,
    },
    values: {
      type: Array,
      default: () => {
        return [];
      },
    },
    perClass: {
      type: Number,
      default: 0,
    },
    interval: {
      type: Number,
      default: 0,
    },
  },
  mounted() {
    if (this.values) {
      this.data = this.values;
    }
  },
  data() {
    return {
      weekDaysItems: WEEK_DAY_ITEMS,
      hoursItemsHalf: [
        "06:00",
        "06:30",
        "07:00",
        "07:30",
        "08:00",
        "08:30",
        "09:00",
        "09:30",
        "10:00",
        "10:30",
        "11:00",
        "11:30",
        "12:00",
        "12:30",
        "13:00",
        "13:30",
        "14:00",
        "14:30",
        "15:00",
        "15:30",
        "16:00",
        "16:30",
        "17:00",
        "17:30",
        "18:00",
        "18:30",
        "19:00",
        "19:30",
        "20:00",
        "20:30",
        "21:00",
        "21:30",
        "22:00",
      ],
      hoursItems: [
        "06:00",
        "07:00",
        "08:00",
        "09:00",
        "10:00",
        "11:00",
        "12:00",
        "13:00",
        "14:00",
        "15:00",
        "16:00",
        "17:00",
        "18:00",
        "19:00",
        "20:00",
        "21:00",
        "22:00",
      ],
      data: [
        {
          weekDay: null,
          from: null,
          to: null,
        },
      ],
    };
  },
  methods: {
    increaseArray() {
      this.data.push({
        weekDay: null,
        from: null,
        to: null,
      });
    },
    getData() {
      return this.data;
    },
    removeItem(index) {
      this.data.splice(index, 1);
    },
    updateDates(value) {
      const parsed = parse(value, "HH:mm", new Date());
      const newTime = addMinutes(parsed, this.perClass);
      return format(newTime, "HH:mm");
    },
    recalculate() {
      if (this.data.length > 0)
        for (let index = 0; index < this.data.length; index++) {
          if (this.data[index].from) {
            this.data[index].to = this.updateDates(this.data[index].from);
          }
        }
    },
  },
  watch: {
    data: {
      handler(value) {
        for (let item of value) {
          if (item.from) {
            item.to = this.updateDates(item.from);
          }
        }
      },
      deep: true,
    },
    perClass() {
      this.recalculate();
    },
  },
};
</script>
<style scoped></style>
